<template>
  <div class="partListPage">
    <el-table
      stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
    >
      <el-table-column
        type="index"
        :width="pagination.endIndex >= 1000 ? 80 : 50"
        align="center"
        :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column
        prop="sn"
        label="配件SN"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.sn">{{ scope.row.sn }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="配件名"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.name">{{ scope.row.name.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="零件"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.type">{{ scope.row.type.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="device"
        label="产品SN"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.device">{{ scope.row.device.sn ? scope.row.device.sn : "【未生成SN】" }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        class-name="operation"
        label="操作"
        width="95px"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.name.code!='FourthG'" class="allowSkip" @click="unbindPart(scope.row)">解绑</span>
          <span v-if="scope.row.name.code=='FourthG' && scope.row.device" class="allowSkip" @click="unbindPart(scope.row)">解绑</span>
          <span v-if="scope.row.name.code=='FourthG' && !scope.row.device" class="allowSkip" @click="unbindPart(scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getProOrderPartList"
    ></pagination>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import {
  apiProOrderPartList,
  apiPartUnbindDevice,
  apiPartUnbind,
} from "@/api/productionOrder.js";
export default {
  components: {
    pagination,
  },
  props: {
    tabPaneValue: {
      type: String,
    },
    partListForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
    };
  },
  methods: {
    // 表格数据
    async getProOrderPartList(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiProOrderPartList({
        productionOrderId: this.tabPaneValue,
        ...this.partListForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getProOrderPartList();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getProOrderPartList();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getProOrderPartList();
    },
    // 解绑配件
    unbindPart(row) {
      let unbindName = row.device ? "配件" : "零件";
      let verifyValue = row.device ? (row.device.sn || row.sn) : row.sn;
      const h = this.$createElement;
      this.$msgbox({
        title: `解绑${unbindName}`,
        message: h("div", null, [
          h("span", null, `输入完整的`),
          h("span", null, `${row.device?"产品SN":"配件SN"}：【`),
          h("i", { style: "color: var(--themeColor)" }, verifyValue),
          h("span", null, `】以确认解绑！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确定解绑`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue === verifyValue) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        let res = {};
        if (unbindName == "配件") {
          res = await apiPartUnbindDevice({
            id: row.device.id,
            orderId: row.productionOrder.id,
            orderType: 0
          });
        } else if (unbindName == "零件") {
          res = await apiPartUnbind({
            id: row.id,
            orderId: row.productionOrder.id,
            orderType: 0
          });
        }
        if (res.code == 0) {
          this.getProOrderPartList("noRemove");
          this.$message({
            message: `解绑${unbindName}成功`,
            type: "success",
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.partListPage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>